<template>
<div class="wlx-ph-login">
    <div class="login-hade-tab clearfix">
        <div class="user-account-login">
            <span>找回密码</span>
        </div>
    </div>
    <div class="login-form-input clearfix">
        <el-steps :active="activeIndex" finish-status="success">
            <el-step title="确认账号"></el-step>
            <el-step title="找回密码"></el-step>
        </el-steps>
        <el-form ref="form" :model="ruleForm" :rules="rules">
            <div v-if="activeIndex == 0">
                <div class="from-account-login">
                    <el-form-item style="margin-top:22px">
                        <div class="select-school-con">
                            <el-select filterable clearable disabled v-model="ruleForm.schoolId" placeholder="请选择学校" class="form_input">
                                <el-option v-for="item in schoolList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                            </el-select>
                            <div class="to-select-btn" @click="toSelectSchool"></div>
                        </div>
                        <div class="left-icon">
                            <i class="wl-icon-xuexiao"></i>
                        </div>
                    </el-form-item>
                    <el-form-item prop="userName" style="margin-top:22px">
                        <el-input placeholder="请输入账号" prefix-icon="wl-icon-yonghu" v-model="ruleForm.userName"></el-input>
                    </el-form-item>
                </div>
                <el-form-item>
                    <el-button type="primary" @click="nextStep">下一步</el-button>
                </el-form-item>
            </div>
            <div v-if="activeIndex == 1">
                <p style="margin-top:22px">{{ruleForm.phoneNum}}</p>
                <el-form-item prop="verfyCode" style="margin-top:22px">
                    <div class="clearfix get-verfycode-con">
                        <el-input v-model="ruleForm.verfyCode" prefix-icon="wl-icon-yanzhengma1" placeholder="请输入验证码" style="width: calc(100% - 140px);margin-right: 20px;"></el-input>
                        <el-button v-if="show1" type="primary" @click="sendMessage()" class="get-message-btn fr">获取验证码</el-button>
                        <el-button v-if="show2" type="primary" class="get-message-btn fr">{{count}}s</el-button>
                        <el-button v-if="show3" type="primary" @click="sendMessage()" class="get-message-btn fr">重新获取验证码</el-button>
                    </div>
                </el-form-item>
                <el-form-item prop="password" style="margin-top:22px">
                    <el-input type="password" prefix-icon="wl-icon-mima1" v-model="ruleForm.password" placeholder="请输入密码"></el-input>
                </el-form-item>
                <el-form-item prop="surePassword" style="margin-top:22px">
                    <el-input type="password" prefix-icon="wl-icon-mima1" v-model="ruleForm.surePassword" placeholder="请再次输入密码"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="complete('form')">完成</el-button>
                </el-form-item>
            </div>
            <p class="p-enter-register clearfix">
                <span class="sp-left" @click="goHome">返回首页</span>
            </p>
        </el-form>
    </div>
</div>
</template>

<script>
import {
    MU_UPATE_AUTH,
    MU_UPATE_SCHOOL
} from "store/index";
import redirect from "api/v1.commom.login.ts";
import CryptoJS from "crypto-js";
export default {
    data() {
        return {
            ruleForm: {
                schoolId: "",
                userName: "",
                phoneNum: "",
                password: "",
                surePassword: '',
                verfyCode: ""
            },
            schoolList: [],
            rules: {
                schoolId: [{
                    required: true,
                    message: "请选择学校",
                    trigger: "change"
                }],
                userName: [{
                    required: true,
                    message: "请输入用户账号",
                    trigger: "blur"
                }],
                password: [{
                    required: true,
                    message: "请输入密码",
                    trigger: "blur"
                }],
                verfyCode: [{
                    required: true,
                    message: "请输入验证码",
                    trigger: "blur"
                }],
                surePassword: [{
                    required: true,
                    message: "请再次输入密码",
                    trigger: "blur"
                }],
            },
            activeIndex: 0,
            userId: '',
            show1: true,
            show2: false,
            show3: false,
            count: 60,
            verifyCode: ''
        };
    },
    props: {
        schoolId: {
            type: String,
            default: ''
        }
    },
    computed: {
        userInfo() {
            return this.$store.state.auth;
        },
        association: function () {
            return this.$store.state.association;
        },
    },
    created() {
        if (localStorage["userId"] !== undefined) {
            this.$store.dispatch(MU_UPATE_AUTH).then((rt) => {});
        }
        this.$store.dispatch(MU_UPATE_SCHOOL, {
            id: window.location.href
        });
        this.getSchoolList();
    },
    methods: {
        complete(formName) {
             var that = this;
            this.$refs[formName].validate(valid => {
                if (valid) {
                    that.RetrievePwd();
                } else {
                    this.$message({
                        message: "请输入信息",
                        type: "error"
                    });
                    return false;
                }
            });
        },
        RetrievePwd() {
            var that = this;
            this.$http.post("/api/XOrg/XLogin/RetrievePwd", {
                userId: that.userId,
                moblie: that.ruleForm.phoneNum,
                shortMessage: that.ruleForm.verfyCode,
                passWord: that.ruleForm.password,
                associationId: that.association.Id
            }).then(rst => {
                if (rst.code > 0) {
                    const h = that.$createElement;
                    that.$message({
                        message: h("div", null, [
                            h("p", null, [
                                h("span", {
                                    style: "color: #000"
                                }, "密码更改成功")
                            ]),
                            h("p", null, [
                                h("span", {
                                    style: "color: #000"
                                }, "正在跳转到登录页...")
                            ])
                        ]),
                        type: "success",
                        duration: 3000
                    });
                    setTimeout(that.backToHome, 3000);
                } else {
                    that.$message({
                        message: rst.msg,
                        type: 'warning'
                    });
                }
            });
        },
        backToHome() {
            this.$router.push({
                name: "xIndex"
            });
        },
        encryption: function (str) {
            let Base64 = require("js-base64").Base64;
            return Base64.encode(str);
        },
        nextStep() {
            if (this.ruleForm.schoolId == '') {
                return this.$message.warning('请选择学校!');
            }
            if (this.ruleForm.userName == '') {
                return this.$message.warning('请输入账号!');
            }
            this.$http.post("/api/XOrg/XLogin/getUserPhone", {
                schoolId: this.ruleForm.schoolId,
                userName: this.ruleForm.userName,
            }).then(rst => {
                if (rst.code > 0) {
                    this.ruleForm.phoneNum = rst.info.mobile;
                    this.userId = rst.info.id;
                    this.activeIndex = 1;
                } else {
                    this.$message({
                        message: rst.msg,
                        type: 'warning'
                    });
                }
            });
        },
        sendMessage() {
            var once = true;
            let str_ = Date.parse(new Date()) / 1000;
            let str = this.encryption(str_);
            let str1 = CryptoJS.MD5(str_ + "").toString();
            var s1 = str1.substring(0, 7);
            var s2 = str1.substring(7);
            str1 = s1 + "s" + s2;
            if (once) {
                var that = this;

                this.$http.post("/api/XOrg/XLogin/sendCodeByUser", {
                    userId: that.userId,
                    str: str,
                    str1: str1
                }).then(rst => {
                    if (rst.code > 0) {
                        this.$message.success(rst.msg);
                        this.verifyCode = rst.verifyCode;
                        const TIME_COUNT = 60;
                        if (!this.timer) {
                            this.count = TIME_COUNT;
                            this.show1 = false;
                            this.show2 = true;
                            this.show3 = false;
                            this.timer = setInterval(() => {
                                if (this.count > 0 && this.count <= TIME_COUNT) {
                                    this.count--;
                                    once = false;
                                } else {
                                    this.show1 = false;
                                    this.show2 = false;
                                    this.show3 = true;
                                    clearInterval(this.timer);
                                    this.timer = null;
                                    once = true;
                                }
                            }, 1000);
                        }
                    } else {
                        this.$message.warning(rst.msg);
                    }
                });
            }
        },
        toSelectSchool() {
            this.$router.push({
                name: 'selectSchool',
                params: {
                    type: 'retrieve'
                }
            });
        },
        getSchoolList() {
            var that = this;
            this.$http
                .post("/api/common/login/getSchoolList", {
                    schoolType: "zwl",
                })
                .then((rst) => {
                    if (rst.code > 0) {
                        that.schoolList = rst.list;
                        if (that.schoolId != '') {
                            that.ruleForm.schoolId = that.schoolId;
                        }
                    } else {
                        this.$message.warning(rst.msg);
                    }
                });
        },
        goHome() {
            this.$router.push({
                name: "xIndex",
            });
        },
        enterRegister() {
            this.$router.push({
                name: "phRegister",
            });
        },
        login: function () {
            var that = this;
            this.loadingTip(true);
            this.$http
                .post("/api/XOrg/XLogin/Accountlogin", {
                    userName: that.ruleForm.userName,
                    userPwd: that.ruleForm.password,
                    schoolId: that.ruleForm.schoolId,
                })
                .then((rst) => {
                    if (rst && rst.code > 0) {
                        if (rst.code === 1) {
                            localStorage["userName"] = this.ruleForm.userName;
                            localStorage["userId"] = rst.userId;
                        }
                        this.$store.dispatch(MU_UPATE_AUTH).then((rt) => {
                            this.loadingTip(false);
                            // 登录完获取回登录信息跳转
                            this.$router.push({
                                name: "xIndex",
                            });
                        });
                    } else {
                        this.loadingTip(false);
                        this.$message.warning(rst.msg);
                    }
                });
        },
        loadingTip(is) {
            if (is) {
                this.$loading({
                    lock: true,
                    text: "正在登录...",
                });
            } else {
                this.$loading({}).close();
            }
        },
        target_() {
            let Urlname = "";
            if (this.$store.state.auth.userType === 1) {
                Urlname = "stuBasicInfo";
            } else if (this.$store.state.auth.userType === 2) {
                Urlname = "xIndex";
            } else if (this.$store.state.auth.userType === 3) {
                Urlname = "siteBasicInfo";
            } else if (this.$store.state.auth.userType === 5) {
                Urlname = "managerIndex";
            }
            return Urlname;
        },
    },
};
</script>

<style lang="scss">
.wlx-ph-login {
    height: 100%;
    background: #fff;

    .get-verfycode-con {
        .get-message-btn {
            padding:12px 5px;
            width: 110px;
        }
    }

    .left-icon {
        position: relative;

        .wl-icon-xuexiao1 {
            position: absolute;
            top: -42px;
            left: 15px;
            font-size: 20px;
            color: #666666;
        }
    }

    .el-select {
        width: 100%;

        .el-input__inner {
            width: 100%;
            padding-left: 45px;
        }
    }

    .el-input__prefix {
        margin-left: 9px;
        font-size: 20px;
        color: #666666;
    }

    .el-input__inner {
        padding-left: 46px;
    }

    .login-role-tab {
        position: absolute;
        right: -94px;
        top: 0;

        .login-role-tab-li {
            width: 94px;
            height: 40px;
            background: rgba(51, 51, 51, 0.5);
            color: #fff;
            line-height: 40px;
            text-align: center;
            font-size: 14px;
            margin-bottom: 10px;
            cursor: pointer;
        }

        .active_role {
            background: #333333;
        }
    }

    .login-hade-tab {
        font-size: 18px;
        color: #2d82ff;
        text-align: center;
        line-height: 50px;
        cursor: pointer;

        .user-account-login {
            float: left;
            width: 100%;
            border-bottom: 2px solid #2d82ff;
        }
    }

    .login-form-input {
        padding: 0 20px;
        margin-top: 35px;

        .go-register-right {
            float: right;
            color: #297efd;
            font-size: 12px;
            font-weight: 500;
            cursor: pointer;

            i {
                font-size: 22px;
                vertical-align: -3px;
            }
        }

        .captcha-phone-input {
            float: left;
            width: 266px;
        }

        .captcha-phone-button {
            float: right;
            width: 138px;
            font-size: 14px;
        }
    }

    .el-button--primary {
        color: #fff;
        background-color: #2d82ff;
        border-color: #2d82ff;
        width: 100%;
    }

    .p-enter-register {
        color: #2d82ff;

        .sp-left {
            float: left;
        }

        .sp-right {
            float: right;
        }

        .sp-forget-password {
            margin-right: 20px;
        }
    }

    .el-input {
        font-size: 16px;
        color: #666666;
    }

    .from-account-login {
        position: relative;

        .wl-icon-xuexiao {
            font-size: 18px;
            position: absolute;
            top: -41px;
            left: 17px;
        }

        .select-school-con {
            position: relative;

            .el-input__inner {
                color: #666;
            }

            .to-select-btn {
                position: absolute;
                width: 100%;
                height: 40px;
                top: 0;
                left: 0;
                z-index: 100;
            }
        }
    }
}
</style>
